import {
  Backdrop,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Portal,
} from "@material-ui/core";
import React, { useState } from "react";
import { useOrderHandler } from "../../hooks/rest";

function CancelOrderItemDialog({
  order,
  itemToCancel,
  openCancelModal,
  setOpenCancelModal,
  updateOrderDetails,
}) {
  const { cancelOrderItem } = useOrderHandler();
  const [loading, setLoading] = useState(false);

  const handleCancelItemConfirm = () => {
    if (order && itemToCancel) {
      setLoading(true);
      const [respUpdateOrderItemFfmCenter] = cancelOrderItem({
        orderId: order.orderId,
        orderItemId: itemToCancel.orderItemId,
        storeId: order.store.storeId,
      });
      respUpdateOrderItemFfmCenter
        .then((resp) => {
          updateOrderDetails();
          setLoading(false);
          setOpenCancelModal(false);
        })
        .catch(() => {
          // TODO Handle Error
          setLoading(false);
        });
    }
  };

  return (
    <>
      <Dialog open={openCancelModal} onClose={() => setOpenCancelModal(false)}>
        <DialogTitle>
          Confirmar Acción
          <Button
            onClick={() => setOpenCancelModal(false)}
            style={{
              position: "absolute",
              top: 8,
              right: 8,
            }}>
            X
          </Button>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Hacer click en Aceptar para cancelar el order item.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleCancelItemConfirm}
            variant="contained"
            color="primary">
            {loading ? "Cancelando..." : "Aceptar"}
          </Button>
        </DialogActions>
      </Dialog>
      <Portal>
        <Backdrop
          sx={{
            color: "#fff",
            zIndex: 2000,
          }}
          style={{
            zIndex: 2000,
          }}
          open={loading}>
          <CircularProgress color="primary" />
        </Backdrop>
      </Portal>
    </>
  );
}

export default CancelOrderItemDialog;
